import { defineMessages } from 'react-intl-next';

export default defineMessages({
	addToSpaceButton: {
		id: 'smart-creation.preview.addToSpaceButton',
		defaultMessage: 'Add to space',
		description:
			'The button in the preview component for adding the preview content to current space.',
	},
});
